// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertInfo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9,18 C13.9702148,18 18,13.9716679 18,9 C18,4.03123819 13.9702148,0 9,0 C4.02978516,0 0,4.03123819 0,9 C0,13.9716679 4.02978516,18 9,18 Z M9,7.04032258 C8.15819919,7.04032258 7.47580645,6.35792985 7.47580645,5.51612903 C7.47580645,4.67432822 8.15819919,3.99193548 9,3.99193548 C9.84180081,3.99193548 10.5241935,4.67432822 10.5241935,5.51612903 C10.5241935,6.35792985 9.84180081,7.04032258 9,7.04032258 Z M10.5967742,13.6451613 L7.40322581,13.6451613 C7.16273154,13.6451613 6.96774194,13.4501717 6.96774194,13.2096774 L6.96774194,12.3387097 C6.96774194,12.0982154 7.16273154,11.9032258 7.40322581,11.9032258 L7.83870968,11.9032258 L7.83870968,9.58064516 L7.40322581,9.58064516 C7.16273154,9.58064516 6.96774194,9.38565556 6.96774194,9.14516129 L6.96774194,8.27419355 C6.96774194,8.03369928 7.16273154,7.83870968 7.40322581,7.83870968 L9.72580645,7.83870968 C9.96630072,7.83870968 10.1612903,8.03369928 10.1612903,8.27419355 L10.1612903,11.9032258 L10.5967742,11.9032258 C10.8372685,11.9032258 11.0322581,12.0982154 11.0322581,12.3387097 L11.0322581,13.2096774 C11.0322581,13.4501717 10.8372685,13.6451613 10.5967742,13.6451613 Z"
            />
        </svg>
    );
};

export default React.memo(AlertInfo);
